import logo from '../../assets/elby.png';
import { FaInstagram, FaLinkedin, FaYoutube, FaTiktok, FaMedium, FaGithub, FaWhatsapp } from 'react-icons/fa';
import { SiBuymeacoffee, SiLinktree } from 'react-icons/si';
import { Link } from 'react-router-dom';
import './footer.css';

function Footer() {
return (
<footer className="footer">
      <div className="footer-container">
        {/* Branding */}
        <div className="footer-branding">
          <img src={logo} alt="Logo" className="footer-logo" />
          <p className="footer-copy">© Loubna Bouzenzen 2026. All rights reserved.</p>
          <div className="social-icons">
            <a href="https://wa.me/213654683600" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
            <a href="https://youtube.com/@elbylit?si=xDgz-4W4zLmCvdmx" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            <a href="https://www.instagram.com/elbylit?igsh=MWM1aXFscXdxejNwcA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://www.tiktok.com/@elbylit?_t=ZS-90Ixi7TO6Px&_r=1" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
            <a href="https://www.linkedin.com/in/loubna-bouzenzen-86a6441b8/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            <a href="https://medium.com/@iamloubna" target="_blank" rel="noopener noreferrer"><FaMedium /></a>
            <a href="https://github.com/Elby2112" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
            <a href="https://buymeacoffee.com/elby" target="_blank" rel="noopener noreferrer"><SiBuymeacoffee /></a>
            <a href="https://linktr.ee/elbylit" target="_blank" rel="noopener noreferrer"><SiLinktree /></a>
          </div>
        </div>
        {/* Links */}
        <div className="footer-links">
          <div>
            <h4>More</h4>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div>
            <h4>Products</h4>
            <Link to="/before-we-get-older">Before We Get Older</Link>
            <Link to="/the-in-between">The In-Between</Link>
          </div>
          <div>
            <h4>Explore</h4>
            <Link to="/tech-projects">Tech Projects</Link>
            <Link to="/portfolio">Portfolio</Link>
            <Link to="/library">Loubna's Library</Link>
            <Link to="/journaling">Journaling Tips</Link>
            <Link to="/book-events">Book Events</Link>
          </div>
        </div>
      </div>
    </footer>
);
}

export default Footer;